// 腾讯地图

// 注意 JavaScript API GL使用的坐标格式是{纬度lat, 经度lng}，即纬度在前，经度在后
// 每次生成的地图都可以通过对应的dom ID找到，方便左后续处理

let mapObj = {};  //地图
let markerLayer = {};  //点图层
let polylineLayer = {};  //折线图层
let districtObj = {};
let searchObj = {};
let geometryEditor = {}; //编辑器
let multiPolygon = {}; //多边形图层
let heatMap = {}; // 热力图层
let circleLayer = {};//圆形图层

export default {
	//异步加载js
	loaded(version, key, callbackName) {
		let url = 'https://map.qq.com/api/gljs?libraries=tools,visualization,service&v=' + (version ? version : '2.exp') + '&key=' + (key ? key : 'K2SBZ-B2TKG-MP2QO-IN74T-VSLV7-ZKBCB');
		if (callbackName) {
			url += '&callback=' + callbackName;
		}
		let amapDom = document.createElement('script');
		amapDom.src = url;
		amapDom.type = 'text/javascript';
		document.head.appendChild(amapDom);
	},
	//初始化地图
	initMap(domId, { lng, lat, zoom }) {
		if (mapObj[domId]) {
			return
		}
		let data = {
			viewMode: '2D',
		};
		if (zoom) {
			data.zoom = zoom;
		}
		if (lng && lat) {
			data.center = new TMap.LatLng(lat, lng)
		}
		mapObj[domId] = new TMap.Map(domId, data);
		//移除缩放、罗盘、比例尺控件
		if (mapObj[domId].getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM)) {
			mapObj[domId].removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
			mapObj[domId].removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
			mapObj[domId].removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE);
		}

		return mapObj[domId]
	},
	// 修改地图中心点
	setCenter(domId, lng, lat) {
		if (mapObj[domId]) {
			mapObj[domId].setCenter(new TMap.LatLng(lat, lng));
		}
	},
	// 地图轨迹
	mapPath(domId, lineData) {
		if (mapObj[domId]) {
			let startMarker, endMarker, lineArr = lineData
			const markerStyle = {
				'markerStart': {
					src: 'https://webapi.amap.com/theme/v1.3/markers/n/start.png',

				},
				'markerEnd': {
					src: 'https://webapi.amap.com/theme/v1.3/markers/n/end.png',
				}
			}

			// 起点
			addMarker(domId, {
				lng: lineArr[0][0],
				lat: lineArr[0][1],
				icon: {
					styleId: 'markerStart'
				}
				, zoom: 13
				, markerStyle: markerStyle
			}, {})
			// 终点
			addMarker(domId, {
				lng: lineArr[lineArr.length - 1][0],
				lat: lineArr[lineArr.length - 1][1],
				icon: {
					styleId: 'markerEnd'
				}
				, zoom: 13
				, markerStyle: markerStyle
			}, {})
			// 绘制轨迹
			//初始化图层
			polylineLayer[domId.className] = new TMap.MultiPolyline({
				id: domId.className, //图层唯一标识
				map: mapObj[domId],//绘制到目标地图
				//折线样式定义
				styles: {
					'style_blue': new TMap.PolylineStyle({
						'color': '#0091ff', //线填充色
						'width': 8, //折线宽度
						'borderWidth': 2, //边线宽度
						'borderColor': '#ffeeee', //边线颜色
						'lineCap': 'round', //线端头方式
						'showArrow': true,
					}),
				},
				//折线数据定义
				geometries: [
					{//第1条线
						'styleId': 'style_blue',//绑定样式名
						'paths': [new TMap.LatLng(40.038540, 116.272389), new TMap.LatLng(40.038844, 116.275210), new TMap.LatLng(40.041407, 116.274738)]
					},
				]
			});
			setFitView(domId)
		}
	},
	// 销毁地图
	destroyMap(domId) {
		if (mapObj[domId]) {
			districtObj = {};
			searchObj = {};
			this.clearMap(domId);
			try {
				geometryEditor[domId.className].destroy();
				geometryEditor[domId.className] = null;
			} catch (e) {
			}
			mapObj[domId].destroy();
			mapObj[domId] = null;
		}
	},
	//清除地图
	clearMap(domId) {
		if (markerLayer[domId.className]) {
			try {
				markerLayer[domId.className].setMap(null);
				markerLayer[domId.className] = null;
			} catch (e) {
			}
		}
		if (polylineLayer[domId.className]) {
			polylineLayer[domId.className].setMap(null);
			polylineLayer[domId.className] = null;
		}
		if (multiPolygon[domId.className]) {
			multiPolygon[domId.className].setMap(null);
			multiPolygon[domId.className] = null;
		}
		if (geometryEditor[domId.className]) {
			geometryEditor[domId.className].setMap(null);
			geometryEditor[domId.className].destroy();
			geometryEditor[domId.className] = null
		}
		if (multiPolygon[domId.className + '_editor']) {
			multiPolygon[domId.className + '_editor'].setMap(null);
			multiPolygon[domId.className + '_editor'] = null;
		}
		if (geometryEditor[domId.className + '_editor']) {
			geometryEditor[domId.className + '_editor'].setMap(null);
			geometryEditor[domId.className + '_editor'].destroy();
			geometryEditor[domId.className + '_editor'] = null
		}
		if (heatMap[domId.className]) {
			heatMap[domId.className].remove();
			heatMap[domId.className] = null;
		}
		if (circleLayer[domId.className]) {
			circleLayer[domId.className].setMap(null);
			circleLayer[domId.className] = null;
		}
	},
	//创建并初始化marker图层
	initMarkerLayer(map, markerStyle, geometries = []) {
		let style = {};
		//样式定义
		for (let item in markerStyle) {
			style[item] = new TMap.MarkerStyle(markerStyle[item]);
		}
		//点击高亮，测试按钮拖动
		// style.highlight=new TMap.MarkerStyle({
		// 	"src": "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/marker-pink.png"
		// })
		//初始化marker图层
		markerLayer[map.drawContainer.className] = new TMap.MultiMarker({
			map: map,  //指定地图容器
			styles: style, //样式定义
			geometries: geometries //点标记数据数组
		});
	},
	//添加点标记
	addMarker(domId, { lng, lat, icon, shadow, offset, label, zIndex, draggable, zoom, markerStyle }, callbackOptions) {
		//高德地图参数：shadow（未找到）
		if (mapObj[domId]) {
			if (offset) {
				for (let i in markerStyle) {
					markerStyle[i].offset = { x: offset[0], y: offset[1] }
				}
			}
			//初始化图层
			if (!markerLayer[domId.className]) {
				this.initMarkerLayer(mapObj[domId], markerStyle)
			}
			//增加点
			let marker = [{
				// "id": "3",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
				"styleId": icon.styleId,  //指定样式id
				"position": new TMap.LatLng(lat, lng),  //点标记坐标位置
				'content': label ? label.content : null,
				'rank': zIndex ? zIndex : 100, //标注点的图层内绘制顺序。
			}]
			markerLayer[domId.className].add(marker);
			//定位
			if (lng && lat) {
				mapObj[domId].setCenter(new TMap.LatLng(lat, lng));
				if (zoom) {
					mapObj[domId].setZoom(zoom);
				}
			}
			//type == 'all',并触发回调
			if (callbackOptions && callbackOptions.type && callbackOptions.type == 'all') {
				let position = { lat: lat, lng: lng };
				callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
			}
			//type == 'dragend' 点可拖拽，并触发回调
			if (draggable) {
				const editor = new TMap.tools.GeometryEditor({
					map: mapObj[domId], // 编辑器绑定的地图对象
					overlayList: [{
						overlay: markerLayer[domId.className], // 可编辑图层
						id: domId.className + '1',
						selectedStyleId: "highlight"  // 被选中的marker会变为高亮样式
					}],
					actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
					activeOverlayId: domId.className + '1', // 激活图层
					selectable: true
				});
				editor.on('adjust_complete', (res) => {
					let position = res.position;
					if (callbackOptions && callbackOptions.type && (callbackOptions.type == 'dragend' || callbackOptions.type == 'all')) {
						callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
					}
				})
			}
			//type == 'click' 点击，触发回调
			markerLayer[domId.className].on('click', (evt) => {
				let position = evt.geometry.position;
				if (callbackOptions && callbackOptions.type && callbackOptions.type == 'click') {
					callbackOptions.callback && typeof callbackOptions.callback == 'function' && callbackOptions.callback(position);
				}
			})
		}
	},
	// 自动调整显示所有覆盖物
	setFitView(domId,FitBoundsOptions={padding: 100}) {
		let bounds = new TMap.LatLngBounds();
		if (markerLayer[domId.className]) {
			//判断标注点是否在范围内
			markerLayer[domId.className].geometries.forEach(function (item) {
				//若坐标点不在范围内，扩大bounds范围
				if (bounds.isEmpty() || !bounds.contains(item.position)) {
					bounds.extend(item.position);
				}
			})
		}
		if (polylineLayer[domId.className]) {
			markerLayer[domId.className].geometries.forEach(function (item) {
				//若坐标点不在范围内，扩大bounds范围
				if (bounds.isEmpty() || !bounds.contains(item.position)) {
					bounds.extend(item.position);
				}
			})
		}
		if (multiPolygon[domId.className]) {
			multiPolygon[domId.className].geometries.forEach(function (item) {
				//若坐标点不在范围内，扩大bounds范围
				if (bounds.isEmpty() || !bounds.contains(item.position)) {
					bounds.extend(item.position);
				}
			})
		}
		if (circleLayer[domId.className]) {
			circleLayer[domId.className].geometries.forEach(function (item) {
				//若坐标点不在范围内，扩大bounds范围
				item.paths.forEach(a=>{
					if (bounds.isEmpty() || !bounds.contains(a)) {
						bounds.extend(a);
					}
				})

			})
		}
		//设置地图可视范围
		mapObj[domId].fitBounds(bounds, FitBoundsOptions);
	}

	// 地址自动补全
	, autoComplete(key, cityCode, callback) {
		if (!searchObj['suggest']) {
			searchObj['suggest'] = new TMap.service.Suggestion({
				// 新建一个关键字输入提示类
				pageSize: 10, // 返回结果每页条目数
				region: cityCode ? cityCode : '', // 限制城市范围
				regionFix: true, // 搜索无结果时是否固定在当前城市
			});
		}
		//实例化自动完成location:map.getCenter()
		searchObj['suggest'].getSuggestions({ keyword: key })
			.then((result) => {
				// 以当前所输入关键字获取输入提示 result.data;
				let positionList = result.data.filter((poi) => {
					return !(poi.title.indexOf("公交站") != -1 || poi.title.indexOf("地铁站") != -1 || typeof (poi.location) == 'undefined' || poi.location == '');
				})
				positionList.forEach((pObj) => {
					pObj.name = pObj.title
				});
				callback && typeof callback == 'function' && callback(positionList);
			})
			.catch((error) => {
				console.log(error);
			});
	}
	// 重新设置自动补全城市限制
	, setCity(mapId, cityCode) {
		if (!districtObj[mapId]) {
			districtObj[mapId] = new TMap.service.District({
				// 新建一个行政区划类
				polygon: 1, // 返回行政区划边界的类型
			});
		}
		districtObj[mapId]
			.search({ keyword: cityCode })
			.then((res) => {
				// 搜索行政区划信息 result.result
				if (res && res.result && res.result.length > 0 && mapObj[mapId]) {
					mapObj[mapId].setCenter(res.result[0][0].location);
				}
			})
			.catch((error) => {
				console.log(error)
			});
	}
	// 设置地图显示区域
	, setArea(mapId, adCode) {
		if (!districtObj[mapId]) {
			districtObj[mapId] = new TMap.service.District({
				// 新建一个行政区划类
				polygon: 1, // 返回行政区划边界的类型
			});
		}
		districtObj[mapId]
			.search({ keyword: adCode })
			.then((res) => {
				// 搜索行政区划信息 result.result
				if (res && res.result && res.result.length > 0 && mapObj[mapId]) {
					mapObj[mapId].setCenter(res.result[0][0].location);
				}
			})
			.catch((error) => {
				console.log(error)
			});
	}
	// 添加并绘制多边形
	, addPolygon(mapId, options, callback) {
		if (!geometryEditor[mapId.className]) {

			multiPolygon[mapId.className] = new TMap.MultiPolygon({
				map: mapObj[mapId],
			});

			geometryEditor[mapId.className] = new TMap.tools.GeometryEditor({
				map: mapObj[mapId], // 编辑器绑定的地图对象
				overlayList: [{
					overlay: multiPolygon[mapId.className], // 可编辑图层
					id: "polygon",
				}],
				actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
				activeOverlayId: "polygon", // 激活图层
				snappable: true, //吸附
				selectable: true
			});
		}
		geometryEditor[mapId.className].setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW);
		geometryEditor[mapId.className].setSelectable(true);
		geometryEditor[mapId.className].setSnappable(true);
		geometryEditor[mapId.className].enable();
		geometryEditor[mapId.className].on('draw_complete', (geometry) => {
			// 返回格式 和高德统一
			try {
				let data = {
					getPath: () => {
						return geometry.paths
					}
				};
				geometryEditor[mapId.className].disable();
				callback && typeof callback == 'function' && callback(data);
			} catch (e) {
			}
		});
	}
	// 显示多边形
	, newPolygon(mapId, options, callback) {
		let pathList = [];
		options.path.forEach((val, i) => {
			pathList.push(new TMap.LatLng(val[1], val[0]))
		});
		if (pathList.length <= 0) {
			return
		}
		if (!geometryEditor[mapId.className]) {
			multiPolygon[mapId.className] = new TMap.MultiPolygon({
				map: mapObj[mapId],
				geometries: [
					{
						paths: pathList
					}
				]
			});
			// 可编辑图层
			geometryEditor[mapId.className] = new TMap.tools.GeometryEditor({
				map: mapObj[mapId], // 编辑器绑定的地图对象
				overlayList: [{
					overlay: multiPolygon[mapId.className],
					id: "polygon",
				}],
				actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
				activeOverlayId: "polygon", // 激活图层
				snappable: false, //吸附
				selectable: false
			});
			geometryEditor[mapId.className].disable();
		} else {
			multiPolygon[mapId.className].add({
				paths: pathList
			})
			// geometryEditor[mapId.className].addOverlay(new TMap.MultiPolygon({
			// 	map:  mapObj[mapId],
			// 	geometries: [
			// 		{
			// 			paths:pathList
			// 		}
			// 	]
			// }));
			// geometryEditor[mapId.className].setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW);
			// geometryEditor[mapId.className].setSelectable(false);
			// geometryEditor[mapId.className].setSnappable(false);
			// geometryEditor[mapId.className].disable();
		}

		try {
			callback && typeof callback == 'function' && callback();
		} catch (e) {
		}
	}
	// 显示多边形  市场管理模块选择范围用 新写的方法是为了不影响上面的方法
	, newMarketPolygon(mapId, options, callback) {
		let pathList = [];
		options.path.forEach((val, i) => {
			pathList.push(new TMap.LatLng(val[1], val[0]))
		});
		if (pathList.length <= 0) {
			return
		}
		if (!geometryEditor[mapId.className]) {
			multiPolygon[mapId.className] = new TMap.MultiPolygon({
				map: mapObj[mapId],
				geometries: [
					{
						paths: pathList
					}
				]
			});
			// 可编辑图层
			geometryEditor[mapId.className] = new TMap.tools.GeometryEditor({
				map: mapObj[mapId], // 编辑器绑定的地图对象
				overlayList: [{
					overlay: multiPolygon[mapId.className],
					id: "polygon",
				}],
				actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
				activeOverlayId: "polygon", // 激活图层
				snappable: false, //吸附
				selectable: false
			});
			geometryEditor[mapId.className].disable();
		} else {
			multiPolygon[mapId.className].add({
				paths: pathList
			})
			// geometryEditor[mapId.className].addOverlay(new TMap.MultiPolygon({
			// 	map:  mapObj[mapId],
			// 	geometries: [
			// 		{
			// 			paths:pathList
			// 		}
			// 	]
			// }));
			// geometryEditor[mapId.className].setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW);
			// geometryEditor[mapId.className].setSelectable(false);
			// geometryEditor[mapId.className].setSnappable(false);
			// geometryEditor[mapId.className].disable();
		}
		try {
			callback && typeof callback == 'function' && callback();
		} catch (e) {
		}
	}
	// 编辑多边形
	, editPolygon(mapId, options, callback) {
		let pathList = [];
		options.path.forEach((val, i) => {
			pathList.push(new TMap.LatLng(val[1], val[0]))
		});
		if (pathList.length <= 0) {
			return
		}

		if (!geometryEditor[mapId.className + '_editor']) {
			multiPolygon[mapId.className + '_editor'] = new TMap.MultiPolygon({
				map: mapObj[mapId],
				styles: {
					'polygon': new TMap.PolygonStyle({
						'showBorder':true, //是否显示拔起面的边线
						'borderColor': '#f25454', //边线颜色
					})
				},
				geometries: [
					{
						id:'1',
						styleId: 'polygon', //绑定样式名
						paths: pathList
					}
				],
				zIndex:1001
			});
			// 可编辑图层
			geometryEditor[mapId.className + '_editor'] = new TMap.tools.GeometryEditor({
				map: mapObj[mapId], // 编辑器绑定的地图对象
				overlayList: [{
					overlay: multiPolygon[mapId.className + '_editor'],
					id: "polygon",
				}],
				actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
				activeOverlayId: "polygon", // 激活图层
				snappable: true, //吸附
				selectable: true
			});
			geometryEditor[mapId.className + '_editor'].enable();
			geometryEditor[mapId.className + '_editor'].select(['1']);
		}else {
			multiPolygon[mapId.className + '_editor'].add({paths: pathList});
			geometryEditor[mapId.className + '_editor'].enable();
			geometryEditor[mapId.className + '_editor'].setActiveOverlay("polygon");
			geometryEditor[mapId.className + '_editor'].setActionMode(TMap.tools.constants.EDITOR_ACTION.INTERACT);
			geometryEditor[mapId.className + '_editor'].setSelectable(true);
			geometryEditor[mapId.className + '_editor'].select(['1']);
			geometryEditor[mapId.className + '_editor'].setSnappable(true);
		}

		geometryEditor[mapId.className + '_editor'].on('adjust_complete', (geometry) => {
			// 返回格式 和高德统一
			try {
				let data = {
					getPath: () => {
						return geometry.paths
					}
				};
				callback && typeof callback == 'function' && callback(data);
			} catch (e) {
			}
		});

		window.oncontextmenu=()=>{
			console.log('鼠标点击了右键 关闭编辑功能')
			if (geometryEditor[mapId.className + '_editor']){
				geometryEditor[mapId.className + '_editor'].setSnappable(false);
				geometryEditor[mapId.className + '_editor'].setSelectable(false);
				geometryEditor[mapId.className + '_editor'].disable();
			}
		};
	}
	// 关闭多边形编辑模式
	, closePolygon(editPolygon) {

	}
	// 清除覆盖物（分类型）
	, clearOverlays(mapId, type, callback) {
		if (mapObj[mapId]) {
			// let overlays = mapObj[mapId].getAllOverlays(type);
			// mapObj[mapId].remove(overlays);
			if (type == 'marker') {
				markerLayer[mapId.className].setMap(null);
				markerLayer[mapId.className] = null;
			} else if (type == 'circle') {
				circleLayer[mapId.className].setMap(null);
				circleLayer[mapId.className] = null;
			} else if (type == 'polygon') {
				if (multiPolygon[mapId.className]) {
					multiPolygon[mapId.className].setMap(null);
					multiPolygon[mapId.className] = null;
				}
				if(geometryEditor[mapId.className]){
					geometryEditor[mapId.className].setMap(null);
					geometryEditor[mapId.className].destroy();
					geometryEditor[mapId.className] = null;
				}
			}
			callback && typeof callback == 'function' && callback();
		}
	}
	// 绘制圆形
	, drawCircle(mapId, lng, lat, options, { type, callback }) {
		if (mapObj[mapId]) {
			if (!circleLayer[mapId.className]) {
				circleLayer[mapId.className] = new TMap.MultiCircle({
					map: mapObj[mapId],
					styles: {},
					geometries: [],
					zIndex: options.zIndex
				});
			}
			//新增样式
			circleLayer[mapId.className].styles[options.id] = new TMap.CircleStyle({
				'color': colorRgba(options.fillColor),
				'showBorder': false,
				'borderWidth': 0,
			})
			//设置zIndex
			circleLayer[mapId.className].setZIndex(options.zIndex)
			//增加圆
			circleLayer[mapId.className].add([{
				styleId: options.id,
				center: new TMap.LatLng(lat, lng),
				radius: options.radius || 100,
				clickCallback:callback
			}])
			function clickCallback(event) {
				event.pixel = event.point;
				if (type && type == 'click') {
					event.geometry.clickCallback && typeof event.geometry.clickCallback == 'function' && event.geometry.clickCallback(event);
				}
			}
			circleLayer[mapId.className].on('click', clickCallback);


			// circle[options.id] = new AMap.Circle({
			//   map: mapObj[mapId],
			//   center: [lng, lat],
			//   radius: options.radius || 100,  // 半径
			//   fillColor:options.fillColor || 'red',  // 圆形填充颜色
			//   strokeColor: options.strokeColor || '#fff', // 描边颜色
			//   strokeWeight: options.strokeWeight || 0,  // 描边宽度
			//   strokeOpacity: options.strokeOpacity || 0.2, // 描边透明度
			//   fillOpacity: options.fillOpacity || 0.25,  // 圆形填充透明度
			// })

		}
	}
	// 生产热力图
	, heatMap(mapId, heatMapId, option, heatmapData) {
		// 判断浏览器是否支持canvas
		const isSupportCanvas = () => {
			let elem = document.createElement('canvas');
			return !!(elem.getContext && elem.getContext('2d'));
		}
		if (!isSupportCanvas()) {
			alert('热力图仅对支持canvas的浏览器适用,您所使用的浏览器不能使用热力图功能,请换个浏览器试试');
		}
		if (mapObj[mapId]) {
			// mapObj[mapId].plugin(['AMap.Heatmap'], () => {
			// 	// 初始化heatmap对象
			// 	if (!heatMap[heatMapId]) {
			// 		heatMap[heatMapId] = new AMap.Heatmap(mapObj[mapId], {
			// 			radius: option.radius || 30, // 默认给定半径30
			// 			opacity: [0, 1],
			// 			gradient: {
			// 				0.1: '#5c49b0',
			// 				0.2: '#38bcf7',
			// 				0.4: '#4acf0b',
			// 				0.6: '#ffeb00',
			// 				1.0: '#e73a00'
			// 			}
			// 		})
			// 	}
			// 	// 设置数据集
			// 	heatMap[heatMapId].setDataSet({
			// 		data: heatmapData,
			// 		max: option.max || 30
			// 	})
			// })

			//创建热力图
			heatMap[heatMapId] = new TMap.visualization.Heat({
				max: option.max || 30, // 热力最强阈值
				opacity: 0.8,
				gradientColor: new TMap.GradientColor({
					stops: {
						0.1: '#5c49b0',
						0.2: '#38bcf7',
						0.4: '#4acf0b',
						0.6: '#ffeb00',
						1.0: '#e73a00'
					}
				}),
				radius: option.radius || 30, // 最大辐射半径 默认给定半径30

			}).addTo(mapObj[mapId]);
			heatMap[heatMapId].setData(heatmapData);//设置数据
		}
	}
	, getInfoWindow(){
		return null;
	}
}

function colorRgba(oldcolor) {
	// 16进制颜色值的正则
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 把颜色值变成小写
	var color = oldcolor.toLowerCase();
	if (reg.test(color)) {
		// 如果只有三位的值，需变成六位，如：#fff => #ffffff
		if (color.length === 4) {
			var colorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
			}
			color = colorNew;
		}
		// 处理六位的颜色值，转为RGB
		var colorChange = [];
		for (var i = 1; i < 7; i += 2) {
			colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
		}
		return "rgba(" + colorChange.join(",") + ",0.25)";
	} else {
		return color;
	}
};





// WEBPACK FOOTER //
// core-dms/projects/candao-dms-std/index/plugs/tmap/index.js